module.exports = __webpack_public_path__ + "static/img/HaiYunFengXianGuanKongJiaShiCang.a0232960.jpg";